import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ArrowCounterClockwiseOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ArrowCounterClockwiseOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
      {title ? <title id={titleId}>{title}</title> : null}
      <path d="M13.75 3c-4.97 0-9.01 4.04-9.01 9v1.04l-3.5-2.55v2.47l4.5 3.27 4.5-3.27v-2.47l-3.5 2.55V12c0-3.86 3.14-7 7.01-7 3.87 0 7.01 3.14 7.01 7s-3.14 7-7.01 7v2c4.97 0 9.01-4.04 9.01-9s-4.04-9-9.01-9Z" fill="currentColor" />
    </svg>;
}) as ForwardedIconComponent);
export default ArrowCounterClockwiseOutlined;